module.exports = __webpack_public_path__ + "img/email-confirmed.a5c293c6.svg";